<template>
  <div class="checkbox-input">
    <label class="checkbox-input__label">
      <input type="checkbox" class="checkbox-input__input" v-model="checked" @change="onChange">
      <span class="checkbox-input__custom-input" v-bind:class="{ 'checked' : checked }"></span>
      {{ field.Name }}
    </label>
  </div>
</template>

<script>
export default {
  name: 'CheckboxInput',
  props: ['field', 'value'],
  data() {
    return {
      proxy: false
    }
  },
  computed: {
    checked: {
      get() {
        return this.value;
      },
      set(value) {
        this.proxy = value;
      }
    }
  },
  methods: {
    onChange(event) {
      this.$emit('input', this.proxy);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/scss/variables";

.checkbox-input {
  width: 100%;
  margin: 30px 0;

  &__label {
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    font-family: $main-font;
    position: relative;
    width: 100%;
  }
  &__input {
    visibility: hidden;
    position: absolute;
    left: 0;
    top: 0;
    transform: translateX(-200%);
  }
  &__custom-input {
    display: inline-block;
    width: 18px;
    height: 18px;
    border-width: 1px; 
    border-style: solid; 
    border-radius: 5px;
    display: flex;
    align-items: center;
    margin-right: 10px;
    flex-shrink: 0;
    margin-top: 1px;

    &.checked {
      position: relative;

      &:after {
        content: '\f00c';
        font-family: 'icomoon';     
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/custom-inputs/CheckboxInput.vue